import type { ISODate } from "../domain/model";

export interface FlexCaloriePlan { days: number[]; regularCalories: number; relaxedCalories: number; averageCalories: number; updatedAt: string }
const STORAGE_KEY = "yumnote.flex-days.v1";

export function calculateFlexLimits(selectedDayCount: number, averageCalories = 2_000, relaxedCalories = 2_500) {
  const count = Math.max(0, Math.min(2, selectedDayCount));
  const regularCalories = count === 0 ? averageCalories : Math.round(((averageCalories * 7 - relaxedCalories * count) / (7 - count)) / 10) * 10;
  return { regularCalories, relaxedCalories, averageCalories };
}

export function saveFlexCaloriePlan(plan: FlexCaloriePlan): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
  window.dispatchEvent(new Event("yumnote:goal-plan"));
}

export function loadFlexCaloriePlan(): FlexCaloriePlan | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as FlexCaloriePlan;
    return Array.isArray(value.days) && Number.isFinite(value.regularCalories) && Number.isFinite(value.relaxedCalories) ? value : null;
  } catch { return null; }
}

export function flexCalorieTargetForDate(date: ISODate, plan = loadFlexCaloriePlan()): number | null {
  if (!plan) return null;
  return plan.days.includes(new Date(`${date}T12:00:00`).getDay()) ? plan.relaxedCalories : plan.regularCalories;
}
